export default [
    {
        path: '/countries',
        name: 'countries',
        meta: {
            layout: 'dashboard'
        },
        component: () => import('VIEWS/Catalogs/Countries.vue')
    }
]